import { STOREFRONT_CART_ATTRIBUTES } from "@tablescape/constants";
import { formatMsrpValue } from "@tablescape/utilities";
import { TablescapeContext, TablescapeEvent } from "@tablescape/context";

export const action = async (e: MouseEvent) => {
  const addToCart = e.target as HTMLElement;
  e.preventDefault();

  if (!addToCart) {
    return;
  }

  const variantSelectorElement = addToCart.closest<HTMLElement>(
    "[data-product-selected-variant-id]"
  );

  if (
    !variantSelectorElement ||
    !variantSelectorElement.dataset?.productSelectedVariantId
  ) {
    return;
  }

  try {
    TablescapeContext.emit(TablescapeEvent.TOGGLE_CART, {
      ui: {
        cartDrawerOpen: true,
        cartDrawerUserToggled: false,
        giftNoteDrawerOpen: false,
        productVariantDrawerOpen: false,
      },
    });

    TablescapeContext.emit(TablescapeEvent.ADD_TO_CART, {
      cart: {
        lines: [
          {
            attributes: [
              {
                key: STOREFRONT_CART_ATTRIBUTES.MSRP,
                value: String(
                  formatMsrpValue(
                    variantSelectorElement.dataset.productSelectedVariantMsrp
                  )
                ),
              },
              ...(variantSelectorElement.dataset
                .productSelectedVariantShippingNote
                ? [
                    {
                      key: STOREFRONT_CART_ATTRIBUTES.PREORDER,
                      value: String(true),
                    },
                  ]
                : []),
            ],
            id: variantSelectorElement.dataset.productSelectedVariantId,
            quantity: 1,
          },
        ],
      },
    });
  } catch (error) {
    console.error(error);
  }
};
